import Api from './baseApi';

export default {
    searchPayment: (Payment) => {
        let url = "/api/payments?v=1";
        if (Payment.search)
            url += `&q=${Payment.search}`;
        if (Payment.type > -1)
            url += `&type=${Payment.type}`;
        if (Payment.transactionStatus > -1)
            url += `&state=${Payment.transactionStatus}`;
        
        if (Payment.startDate)
            url += `&startDate=${Payment.startDate}`;
        if (Payment.endDate)
            url += `&endDate=${Payment.endDate}`;
        if (Payment.insuranceId > -1)
            url += `&insuranceId=${Payment.insuranceId}`;
        return Api.get(url)
    },
    hbStatusGroup: (Order) => {
        let url = "/api/Payments/hbStatusGroup?v=1";
        if (Order.type > -1)
            url += `&type=${Order.type}`;
        if (Order.transactionStatus > -1)
            url += `&state=${Order.transactionStatus}`;

        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        return Api.get(url)
    },
    getPayment: (id) => Api.get(`/api/Payments/${id}`),
    putPayment: (Payment) => Api.put(`/api/Payments/${Payment.id}`, Payment),
    deletePayment: (Payment) => Api.delete(`/api/Payments/${Payment.id}`, Payment),
    postPayment: (Payment) => Api.post(`/api/Payments`, Payment),
    bulkUpdateStates: (Model) => {
        let url = `/api/Payments/bulkUpdateStates`;
        return Api.patch(url, Model);
    },

}